import { BalanceId } from "@bb/game-products-ui";

const BALANCE_INSUFFICIENT_SUBTITLES: Record<BalanceId, string> = {
  [BalanceId.BonusOnline]: "Недостаточно средств на Фрибет балансе",
  [BalanceId.Money]: "Недостаточно средств на Денежном балансе",
  [BalanceId.Bonus]: "Недостаточно средств на Фрибет балансе",
};

export const getBalanceInsufficientSubtitle = (balanceId: BalanceId): string =>
  BALANCE_INSUFFICIENT_SUBTITLES[balanceId];
